import o from "@ui-components-3/ui/lib/components/Input";

import t from "../createFormikField/index.js";

const e = t(o);

export { e as default };
//# sourceMappingURL=index.js.map
